import { render, staticRenderFns } from "./ViewOfferTrade.vue?vue&type=template&id=55b3be2d&scoped=true"
import script from "./ViewOfferTrade.vue?vue&type=script&lang=js"
export * from "./ViewOfferTrade.vue?vue&type=script&lang=js"
import style0 from "./ViewOfferTrade.vue?vue&type=style&index=0&id=55b3be2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b3be2d",
  null
  
)

export default component.exports